import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecordingActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_27836_2515)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.375 1C10.1252 1 7.926 1.66713 6.05539 2.91703C4.18478 4.16693 2.72682 5.94347 1.86588 8.02198C1.00493 10.1005 0.779666 12.3876 1.21857 14.5942C1.65748 16.8007 2.74084 18.8275 4.33167 20.4183C5.92249 22.0092 7.94932 23.0925 10.1559 23.5314C12.3624 23.9703 14.6495 23.7451 16.728 22.8841C18.8065 22.0232 20.5831 20.5652 21.833 18.6946C23.0829 16.824 23.75 14.6248 23.75 12.375C23.7468 9.35914 22.5474 6.46771 20.4148 4.33518C18.2823 2.20264 15.3909 1.00318 12.375 1ZM12.375 22C10.4714 22 8.61046 21.4355 7.02764 20.3779C5.44482 19.3203 4.21116 17.8171 3.48266 16.0583C2.75417 14.2996 2.56356 12.3643 2.93495 10.4973C3.30633 8.63019 4.22302 6.91518 5.5691 5.5691C6.91518 4.22302 8.63019 3.30632 10.4973 2.93494C12.3643 2.56356 14.2996 2.75417 16.0583 3.48266C17.8171 4.21115 19.3203 5.44481 20.3779 7.02764C21.4355 8.61046 22 10.4714 22 12.375C21.9971 14.9268 20.9821 17.3733 19.1777 19.1777C17.3733 20.9821 14.9268 21.9971 12.375 22Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 7,
			width: 11,
			height: 11,
			fill: "#E81C23"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_27836_2515",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgRecordingActive;
